﻿import Page_ from "./components/Page";
import PortailEdit_ from "./components/PortailEdit";
import PortailSecuriteEdit_ from "./components/PortailSecuriteEdit";
// Generique
const Page = require("./components/Page") as Page_;
// // Specifique
const PortailEdit = require("./components/PortailEdit") as PortailEdit_;
const PortailSecuriteEdit = require("./components/PortailSecuriteEdit") as PortailSecuriteEdit_;

export = {
    //== Generic components
    Page,
    //== Custom components
    PortailEdit,
    PortailSecuriteEdit
};
